import chatbotRequest from '@/service/channel/http'
import type { BroadcastTaskListReq, BroadcastTaskListRes } from '../types/getBroadcastTaskList'

export function getBroadcastTaskListApi(data: BroadcastTaskListReq): Promise<BroadcastTaskListRes> {
    return chatbotRequest<BroadcastTaskListRes, BroadcastTaskListReq, BroadcastTaskListRes>({
        url: '/api/broadcast/telegram/task/list',
        method: 'post',
        data,
    })
}